import { KG_CATALOG_SECTIONS } from "./kgCatalog.constants";
import type { KgCatalogSectionId } from "./kgCatalog.types";

import {
  KG_SIDEBAR_SECTION_PATH as REGISTRY_PATHS,
  type KgSidebarSection,
} from "./kgSectionRegistry";

export type { KgSidebarSection };

/** URL segment under `/knowledge-graph/...` for each sidebar section. */
export const KG_SIDEBAR_SECTION_PATH: Record<KgSidebarSection, string> =
  REGISTRY_PATHS;

const pathSegmentToSection = Object.fromEntries(
  Object.entries(KG_SIDEBAR_SECTION_PATH).map(([section, path]) => [
    path,
    section,
  ]),
) as Record<string, KgSidebarSection>;

/** Catalog accordion section → matching KG sidebar nav item. */
export const KG_CATALOG_SECTION_SIDEBAR = Object.fromEntries(
  KG_CATALOG_SECTIONS.map((section) => [section.id, section.sidebarSection]),
) as Record<KgCatalogSectionId, KgSidebarSection>;

export const buildKgSidebarPath = (section: KgSidebarSection): string =>
  `/knowledge-graph/${KG_SIDEBAR_SECTION_PATH[section]}`;

export const resolveKgSidebarSectionFromPath = (
  pathname: string,
): KgSidebarSection => {
  const segments = pathname.split("/").filter(Boolean);
  const segment = segments[1];
  return (segment && pathSegmentToSection[segment]) || "canvas";
};

export const resolveKgCatalogSectionSidebarPath = (
  sectionId: KgCatalogSectionId,
): string => buildKgSidebarPath(KG_CATALOG_SECTION_SIDEBAR[sectionId]);
